<template>
  <div>
    <dashboard-page-title :showSearch="false" :showFilter="false" :showMainActions="false">
      {{$t('trips.trips')}} - #{{ $route.params.id }}
    </dashboard-page-title>
    <b-card class="iq-border-radius-10 mb-3">
      <template v-slot:header>
        <h5 class="text-primary"><i class="las la-file-alt"></i> {{$t('trips.trips')}}</h5>
      </template>
      <div v-if="loading" class="text-center py-5">
        <spinner-loading :text="$t('trips.loading')"></spinner-loading>
      </div>
      <b-row v-else>
        <b-col md="4" class="mb-3">
          <label class="font-size-14 text-gray">{{$t('trips.tripId')}}</label>
          <p class="font-weight-bold">{{ trip.id }}</p>
        </b-col>
        <b-col md="4" class="mb-3">
          <label class="font-size-14 text-gray">{{$t('trips.pickUp')}}</label>
          <p class="font-weight-bold">{{ trip.startAddress }}</p>
        </b-col>
        <b-col md="4" class="mb-3">
          <label class="font-size-14 text-gray">{{$t('trips.pickIn')}}</label>
          <p class="font-weight-bold">{{ trip.endAddress }}</p>
        </b-col>
        <b-col md="4" class="mb-3">
          <label class="font-size-14 text-gray">{{$t('trips.capacityNumber')}}</label>
          <p class="font-weight-bold">{{ trip.noOfCamels }}</p>
        </b-col>
        <b-col md="4" class="mb-3" v-if="trip.distance">
          <label class="font-size-14 text-gray">{{$t('trips.distance')}}</label>
          <p class="font-weight-bold">{{ trip.distance }}</p>
        </b-col>
        <b-col md="4" class="mb-3">
          <label class="font-size-14 text-gray">{{$t('trips.tripPrice')}}</label>
          <p class="font-weight-bold">{{ trip.price }}</p>
        </b-col>
        <b-col md="4" class="mb-3">
          <label class="font-size-14 text-gray">{{$t('trips.date')}}</label>
          <p class="font-weight-bold">{{ trip.dateTime }}</p>
        </b-col>
        <b-col md="4" class="mb-3">
          <label class="font-size-14 text-gray">{{$t('trips.status')}}</label>
          <p>
            <mainstatus :status="String(trip.status)" />
          </p>
        </b-col>
        <b-col md="4" class="mb-3" v-if="trip.driver">
          <label class="font-size-14 text-gray">{{$t('drivers.driverName')}}</label>
          <p class="font-weight-bold">{{ trip.driver.name }}</p>
        </b-col>
        <b-col md="4" class="mb-3" v-if="trip.vehicle">
          <label class="font-size-14 text-gray">{{$t('drivers.vehicles')}}</label>
          <p class="font-weight-bold">{{ trip.vehicle.model }}</p>
        </b-col>
      </b-row>
      <div class="d-flex justify-content-end">
        <b-button variant="primary" @click="$router.push({name: 'companyTrips'})">{{$t('trips.back')}}</b-button>
      </div>
    </b-card>
  </div>
</template>
<script>
import { core } from '@/config/pluginInit'
import mainstatus from '@/components/table/status'
import tripServices from '@/modules/Company/trips/services/trip'
export default {
  components: { mainstatus },
  data () {
    return {
      loading: false,
      trip: {}
    }
  },
  methods: {
    getTrip () {
      this.loading = true
      tripServices.getTrip(this.$route.params.id).then(res => {
        this.trip = res.data
      }).finally(() => {
        this.loading = false
      })
    }
  },
  mounted () {
    core.index()
  },
  created () {
    this.getTrip()
  }
}
</script>
